import {
  CommonProps,
  NumberInput,
  type PropsEditorProps,
  Row,
  Section,
  TextInput,
} from "./common";

export function TextProps(props: PropsEditorProps): JSX.Element {
  const { field, onUpdate } = props;
  return (
    <>
      <CommonProps {...props} />
      <Section title="Validation">
        <Row label="Min length">
          <NumberInput
            value={field.min_length ?? null}
            onChange={(v) => onUpdate({ min_length: v ?? null })}
          />
        </Row>
        <Row label="Max length">
          <NumberInput
            value={field.max_length ?? null}
            onChange={(v) => onUpdate({ max_length: v ?? null })}
          />
        </Row>
        <Row
          label="Regex pattern"
          hint='VD: "^0\d{9,10}$" cho SĐT VN'
        >
          <TextInput
            value={field.pattern ?? ""}
            onChange={(v) => onUpdate({ pattern: v || null })}
          />
        </Row>
      </Section>
    </>
  );
}
